import { allFillings } from '@/components/CakeMaker/data/fillings'
import { shapes } from '@/components/CakeMaker/data/shapes'
import { toppings } from '@/components/CakeMaker/data/toppings'
import { listNames } from '@/utils'

import { MIN_NOTICE_DAYS, STARTING_PRICE } from './constants'

export const FAQ: ReadonlyArray<{
  question: string
  answer: string
}> = [
  {
    question: 'Quanto custa um bolo confeitado?',
    answer: `Nossos bolos confeitados começam em ${STARTING_PRICE.DISPLAY}, referente a um bolo de 1 kg (cerca de 10 fatias) com massa de baunilha e recheio tradicional. O valor final depende do peso, da massa, do recheio escolhido e dos adicionais — você monta o bolo pelo site e vê o preço atualizando em tempo real, sem compromisso.`,
  },
  {
    question: 'Vocês fazem bolo de aniversário e de chá de bebê?',
    answer: `Sim. Bolos de aniversário e de chá de bebê ou chá revelação são nossas especialidades. Fazemos o bolo confeitado no tema da festa, com topo personalizado, nos formatos ${listNames(shapes, 'ou').toLowerCase()}, de 500 g a 5 kg.`,
  },
  {
    question: 'Quais sabores de bolo vocês têm?',
    answer: `Trabalhamos com massa de baunilha e de chocolate, e com ${allFillings.length} recheios: ${listNames(allFillings)}. As coberturas disponíveis são ${listNames(toppings)}.`,
  },
  {
    question: 'Como encomendar?',
    answer:
      'Você pode encomendar pelo site ou através das nossas plataformas de comunicação.',
  },
  {
    question: 'Os bolos têm topo?',
    answer:
      'Você pode optar por um topo ou não. Se a encomenda for feita pelo site, o topo é automaticamente adicionado quando o tema é definido.',
  },
  {
    question: 'Em quanto tempo fica pronto?',
    answer: `Não é possível fazer agendamentos com menos de ${MIN_NOTICE_DAYS} dias de antecedência.`,
  },
  {
    question: 'Entrega em quais regiões?',
    answer:
      'Entregamos em toda a Zona Leste de São Paulo, incluindo Parque do Carmo, Itaquera, Cidade Líder, São Mateus, Aricanduva, Vila Formosa, Carrão, Vila Matilde, Artur Alvim, Penha, Guaianases, Itaim Paulista, São Miguel Paulista, Ermelino Matarazzo, Sapopemba, José Bonifácio e Tatuapé. Atendemos endereços num raio de até 18 km da nossa cozinha, no Jardim Nossa Senhora do Carmo, e a taxa é calculada pela distância.',
  },
  {
    question: 'Quais são os meios de pagamento?',
    answer:
      'Você pode pagar com cartão de crédito, boleto ou pix. É necessário, no mínimo, 50% do valor da encomenda para confirmar a compra.',
  },
]
